import colors from '../_shared/colors';
import styled from '@emotion/styled';

export const P = styled.p`
  font-size: 12px;
  font-weight: 600;
`;

/* AER-1465: antd v6's ConfigProvider sets colorLink to the brand primary,
   which causes its derived colorLinkHover token to render the footer Terms
   of Use / Privacy Policy links in a washed-out lavender on the grey footer
   background (barely readable per QA). Force the hover/focus/active state to
   the darker brand purple so it matches the prior antd v3 behaviour Danielle
   confirmed on QA. Using styled.a (rather than passing &:hover via the
   string-based css() helper) so Emotion's stylis preprocessor reliably picks
   up the nested selector. */
export const PolicyLink = styled.a`
  color: ${colors.white};
  text-decoration: none;

  &:hover,
  &:focus,
  &:active {
    color: ${colors.primary} !important;
    text-decoration: underline;
  }
`;

export default {
  container: `
    background-color: ${colors.footerBg};
    width: 100%;
    min-height: 75px;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    display: flex;
  `,
  extended: `
    position: fixed;
    margin-left: -20px;
    bottom: 0;
    min-height: 40px;
    justify-content: center;
    padding-top: 5px;
  `,
  divider: `
    margin: 0px 5px 0px 5px;
    color: ${colors.white}
  `,
  policyContainer: `
    display: flex;
    align-items: center;
  `,
  policies: `
    color: ${colors.white};
    text-decoration: none;
  `,
  logo_1_container: `
    align-items: space-around;
    display: flex;
    flex-direction: column;
    flex: 1;
  `,
  logo_1_container_centered: `
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
  `,
  logo_2_container: `
    justify-content: flex-end;
    display: flex;
    flex: 1;
    align-items: flex-end;
  `,
  copywrite: `
    margin-right: 10px;
  `,
  copywriteSmall: `
    margin-top -12px;
    font-size: 10px;
    margin-left: 20px;
    line-height: 10px;
  `,
};
